// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppsAppIdPushCredentialResult = objectOf({
  credential: maybe(
    objectOf({
      app_type: string,
      credential_data: objectOf({
        push_certificate: maybe(string),
        huawei_app_secret: maybe(string),
        huawei_app_id: maybe(string),
        sid: maybe(string),
        client_id: maybe(string),
        client_secret: maybe(string),
      }),
    })
  ),
});
